// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1eb5cc81","805":"f54686a8"}[chunkId] + ".chunk.js";
};